import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {ImagesResourcesValueObject} from '../../resources/ValueObjects/ImagesResourcesValueObject.js'
import {MakeSpecificationVehiclesValueObject} from './MakeSpecificationVehiclesValueObject.js'
import {ModelSpecificationVehiclesValueObject} from './ModelSpecificationVehiclesValueObject.js'
import {PriceSpecificationVehiclesValueObject} from './PriceSpecificationVehiclesValueObject.js'

export class ModelVehiclesValueObject extends ValueObject {
  #make
  #model
  #images
  #price

  constructor({make, model, images, price}) {
    super()
    this.#make = make
    this.#model = model
    this.#images = images
    this.#price = price
  }

  static createFromApi({makeId, makeName, modelId, modelName, pictures, price}) {
    return new ModelVehiclesValueObject({
      make: MakeSpecificationVehiclesValueObject.createFromLiteralsWithIcon({
        id: makeId,
        name: makeName
      }),
      model: ModelSpecificationVehiclesValueObject.createFromLiterals({id: modelId, name: modelName}),
      images: ImagesResourcesValueObject.createFromImages({
        images: pictures
      }),
      price: PriceSpecificationVehiclesValueObject.createFromLiterals({
        id: `price-${crypto.randomUUID()}`,
        name: price.manufacturedPrice
      })
    })
  }

  get make() {
    return this.#make.value
  }

  get model() {
    return this.#model.value
  }

  get images() {
    return this.#images.value
  }

  get price() {
    return this.#price.value
  }

  getModelCard() {
    return {
      make: {
        ...this.make,
        slug: this.#make.toSlug()
      },
      model: {
        ...this.model,
        slug: this.#model.toSlug()
      },
      images: this.images,
      price: this.price.name
    }
  }

  getModelCardsForModelDetail() {
    const {VEHICLE_CONFIGURATOR_PATH, MODEL_DETAIL_PATH_PATTERN} = ConfigContext.get('page')
    return {
      make: this.make,
      model: this.model,
      configuratorUrl: `${VEHICLE_CONFIGURATOR_PATH}${this.#make.toSlug()}/${this.#model.toSlug()}/`,
      url: `${MODEL_DETAIL_PATH_PATTERN}${this.#make.toSlug()}/${this.#model.toSlug()}/`,
      images: this.images,
      price: this.price.name
    }
  }

  get value() {
    return {
      make: this.make,
      model: this.model,
      images: this.images,
      price: this.price
    }
  }
}
